import React from "react";
import Styles from './styles.module.scss';




const CabinetHello = (props) => {
    const { title, description } = props;

    return (
        <div className={`${Styles.helloWrap}`}>
            <div className={`${Styles.helloTitle}`}>{title}</div>
            <div className={`${Styles.helloNote}`}>{description}</div>
        </div>
    );
}
export default CabinetHello;
